module.exports = __webpack_public_path__ + "assets/welcome-elsa.205c4dcf.svg";